<!-- Checkbox.vue -->
<template>
  <label class="checkmark_container" :class="[variant]">
    <input
      type="checkbox"
      :checked="checked"
      @change.stop="$emit('change', $event.target.checked)"
    />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
